import buildMeta from '@/router/utils/buildMeta'

const routes = [
  {
    name: 'widget',
    path: '/widget',
    component: () => import('@/pages/Widget/WidgetWrapper.vue'),
    meta: buildMeta({
      authRequired: false,
      hideDistractions: true,
      pageTitle: 'Widget',
      title: 'Widget - Jobscan',
      removeCookieConsent: true,
    }),
    children: [
      {
        name: 'widget-uploader',
        path: '',
        component: () => import('@/pages/Widget/Uploader.vue'),
        meta: buildMeta({
          authRequired: false,
          hideDistractions: true,
          pageTitle: 'Widget',
          title: 'Upload Widget - Jobscan',
        }),
      },
      {
        name: 'widget-uploader-legacy',
        path: 'legacy',
        component: () => import('@/pages/Widget/JdSuggestionsLegacy/Index.vue'),
        meta: buildMeta({
          authRequired: false,
          hideDistractions: true,
          pageTitle: 'Widget',
          title: 'Upload Widget - Jobscan',
        }),
      },
      {
        name: 'widget-scan',
        path: 'scan/:scanId',
        component: () => import('@/pages/Widget/Scan.vue'),
        meta: buildMeta({
          authRequired: false,
          hideDistractions: true,
          pageTitle: 'Widget Scan',
          title: 'Upload Widget - Jobscan',
        }),
        children: [
          {
            name: 'widget-scan-resume',
            path: '',
            component: () => import('@/pages/Scan/Resume.vue'),
            meta: buildMeta({
              authRequired: false,
              hideDistractions: true,
              robots: 'noindex',
            }),
          },
        ],
      },
      {
        name: 'small-scan',
        path: 'small-scan',
        component: () => import('@/pages/Widget/SmallScan/SmallScan.vue'),
        meta: buildMeta({
          authRequired: false,
          hideDistractions: true,
          pageTitle: 'Widget',
          title: 'Upload Widget - Jobscan',
        }),
      },
      {
        name: 'cover-letter-generator',
        path: 'cover-letter-generator',
        component: () => import('@/pages/Widget/CoverLetterGenerator.vue'),
        meta: buildMeta({
          authRequired: false,
          hideDistractions: true,
          pageTitle: 'Widget',
          title: 'Cover Letter Generator Widget - Jobscan',
        }),
      },
      {
        name: 'phrase-suggestions',
        path: 'phrase-suggestions',
        component: () =>
          import('@/pages/Widget/PhraseSuggestions/PhraseSuggestions.vue'),
        meta: buildMeta({
          authRequired: false,
          hideDistractions: true,
          pageTitle: 'Widget',
          title: 'Phrase Suggestions Widget - Jobscan',
        }),
      },
      {
        name: 'scan-widget',
        path: 'scan-widget',
        component: () => import('@/pages/Widget/ScanWidget/ScanWidget.vue'),
        meta: buildMeta({
          authRequired: false,
          hideDistractions: true,
          pageTitle: 'Widget',
          title: 'Upload Widget - Jobscan',
        }),
      },

      {
        name: 'company-hiring-form',
        path: 'company-hiring-form',
        component: () => import('@/pages/Widget/CompanyHiringForm.vue'),
        meta: buildMeta({
          authRequired: false,
          hideDistractions: true,
          pageTitle: 'Company Hiring Widget',
          title: 'Company Hiring Widget - Jobscan',
        }),
      },
    ],
  },
]

export default routes
